import React, { ChangeEvent, useState } from "react";

type CountryCode = {
  code: string;
  dialCode: string;
};

const countryCodes: CountryCode[] = [
  { code: "IN", dialCode: "+91" },
  { code: "US", dialCode: "+1" },
  { code: "UK", dialCode: "+44" },
  { code: "DE", dialCode: "+49" },
  { code: "FR", dialCode: "+33" },
  { code: "JP", dialCode: "+81" },
  { code: "CN", dialCode: "+86" },
  { code: "BR", dialCode: "+55" },
  { code: "AU", dialCode: "+61" },
  { code: "CA", dialCode: "+1" },
];

type CustomInputFieldProps = {
  name: string;
  type?: string;
  label?: string;
  value?: string | number;
  onChange?:
    | ((value: string) => void)
    | ((e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void);
  placeholder?: string;
  showCountryCode?: boolean;
  disabled?: boolean;
};

const CustomInputField: React.FC<CustomInputFieldProps> = ({
  name,
  type = "text",
  label,
  value,
  onChange,
  placeholder,
  showCountryCode = false,
  disabled = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [selectedCountryCode, setSelectedCountryCode] = useState(
    countryCodes[0].dialCode
  );

  const bgColor =
    value && !isFocused ? "bg-[#F2F4F7] font-medium" : "bg-white font-normal";

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    if (type === "tel") {
      newValue = newValue.replace(/\D/g, "");
    }

    if (typeof onChange === "function") {
      if (onChange.length === 1) {
        (onChange as (value: string) => void)(newValue);
      } else {
        (
          onChange as (
            e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
          ) => void
        )(e);
      }
    }
  };

  const handleCountryCodeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSelectedCountryCode(e.target.value);
  };

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={name}
          className="block mb-2 text-sm font-medium text-gray-700"
        >
          {label}
        </label>
      )}
      <div
        className={`relative w-full ${bgColor} border border-[#D0D5DD] rounded-lg overflow-hidden flex h-10`}
      >
        {showCountryCode && (
          <select
            value={selectedCountryCode}
            onChange={handleCountryCodeChange}
            className="bg-transparent text-sm leading-5 tracking-[-0.75%] text-[#101828] ps-2 focus:outline-none"
          >
            {countryCodes.map((country) => (
              <option key={country.code} value={country.dialCode}>
                {country.code}
              </option>
            ))}
          </select>
        )}
        <div className="relative w-full h-full">
          {showCountryCode && (
            <span className="absolute left-2 top-[51%] transform -translate-y-1/2 text-sm text-[#737B95] pointer-events-none">
              {selectedCountryCode} -
            </span>
          )}
          <input
            disabled={disabled}
            id={name}
            name={name}
            type={type}
            value={value}
            onChange={handleInputChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            placeholder={placeholder}
            className={`w-full h-full ${
              showCountryCode ? "pl-[43px] text-[#737B95]" : "pl-3.5"
            } pr-3.5 py-2.5
                text-sm font-medium leading-5
                placeholder:text-[#959FB2] placeholder:text-sm placeholder:font-normal
                focus:outline-none focus:border-transparent
                transition-colors duration-200 bg-transparent`}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomInputField;
